<template>
    <v-container fluid class="pa-0">
        <banner 
            :title="$t('ECreativeResourcesPageTitle')"
            :description="$t('ECreativeResourcesPageDescription')"
        />
        <v-container>
            <v-row justify="center" class="mb-4" v-if="!loadingTopics">
                <v-col cols="12" mg="8" lg="4">
                    <v-row>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-select
                                outlined
                                rounded
                                clearable
                                :dense="$vuetify.breakpoint.smAndDown ? true : false"
                                :menu-props="{ offsetY: true }"
                                :items="topics"
                                item-text="name"
                                item-value="id"
                                v-model="filterTopicId"
                                label="Filter by topic"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        rounded
                                        outlined
                                        clearable
                                        readonly
                                        v-on="on"
                                        :dense="$vuetify.breakpoint.smAndDown ? true : false"
                                        :value="filterDateFormat"
                                        :label="$t('FilterByMonth')"
                                        prepend-icon=""
                                        @click:clear="date = null"
                                    ></v-text-field>
                                </template>
                                <v-date-picker 
                                    no-title 
                                    scrollable
                                    type="month"
                                    color="primary"
                                    v-model="date"
                                    @input="$refs.menu.save(date)" 
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <template v-if="loadingBids">
                <div class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="secondary"
                        indeterminate
                    ></v-progress-circular>
                </div>
            </template>
            <template v-else>
                <template v-if="bids.length > 0">
                    <v-row justify="center" class="px-4 mt-4 mt-lg-6">
                        <v-col 
                            cols="12" 
                            md="6" 
                            lg="3"
                            v-for="(bid, index) in bids"
                            :key="index"
                        >
                            <bid-card 
                                inlineRating
                                hasVotingEnded
                                :topic="getTopicById(bid.project.topicId)"
                                :date="dateFormat(bid.bid.date.localTime)"
                                :topicId="bid.project.topicId"
                                :bid="bid.bid"
                            />
                        </v-col>
                    </v-row>
                </template>
                <template v-else>
                    <div class="headline my-4 my-lg-6 text-center" v-text="$t('NoRecords')"></div>
                </template>
            </template>
        </v-container>
    </v-container>
</template>

<script>
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import Banner from '@/components/pageBanner'
    import BidCard from '@/components/bidCard'

    export default {
        name: 'ecreativeResources',
        data: () => ({
            bids: [],
            topics: [],
            filterTopicId: null,
            menu: false,
            date: '',
            snackbar: {
                show: true,
                message: ''
            },
            loadingBids: true,
            loadingTopics: true
        }),
        computed: {
            ...mapGetters(['user', 'preferedLanguage']),
            filterDate() {
                if(this.date) {
                    return moment(this.date).format()
                }
                return null
            },
            filterDateFormat() {
                return this.date ? moment(this.date).format('MMMM YYYY') : ''
            }
        },
        components: {
            Banner,
            BidCard
        },
        mounted() {
            this.fetchTopics()
            this.fetchResoruces()            
        },
        methods: {
            async fetchTopics() {
                await this.axios.get('/Topic/GetAllTopics', {
                    params: {
                        languageId: this.preferedLanguage
                    }
                })
                .then(response => {
                    this.topics = response.data
                })
                this.loadingTopics = false
            },
            async fetchResoruces() {
                await this.axios.get('/ProjectBid/GetBidResources', {
                    params: {
                        languageId: this.preferedLanguage,
                        topicId: this.filterTopicId,
                        date: this.filterDate
                    }
                })
                .then(response => {
                    this.bids = response.data
                })
                this.loadingBids = false
            },
            getTopicById(id) {
                return this.topics.filter(topic => topic.id == id).map(topic => topic.name)[0]
            },
            dateFormat(date) {
                return moment(date).format('MM/DD/YYYY')
            }
        },
        watch: {
            date() {
                this.fetchResoruces()
            },
            filterTopicId() {
                this.fetchResoruces()
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>